<template>
  <div class="height-0 width-100 mx-auto">
    <span class="headline white--text pa-2">
      {{ $t(`activities.reservation_types.${reservationMethod.type}`) }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    reservationMethod: Object,
  },
}
</script>

<style lang="scss" scoped>
.height-0 {
  height: 0;
}
span {
  top: -24px;
  position: relative;
  border-radius: 10px;
  background-color: var(--v-primary-base);
  margin-right: auto;
  margin-left: auto;
}
</style>
